<template>
  <div class="ActivityReportItem">
    <div class="name">
      {{ label }}
    </div>
    <IncrementInput
      @change="update"
      :disabled="readOnly"
      v-model.number="quantity" />
  </div>
</template>

<script>
const labels = {
  PT_50_MIN: "PT time 50 min",
  PT_25_MIN: "PT time 25 min",
  SERVICE_INTRO: "Servicetimer - introtime",
  SERVICE_CAMPAIGN: "Servicetimer - kampanje",
  SERVICE_OUTSIDE: "Servicetimer - utenfor senter",
  SERVICE_INSIDE: "Servicetimer - på senter",
};

import debounce from "lodash/debounce";
import gql from "graphql-tag";
import IncrementInput from "@/components/IncrementInput";
export default {
  components: { IncrementInput },
  data: function () {
    return {};
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {},

  methods: {
    update: debounce(
      function () {
        console.log("updating item");
        return this.$apollo
          .mutate({
            mutation: gql`
              mutation UpdateActivityReportItemMutation(
                $id: Int!
                $quantity: BigFloat!
              ) {
                __typename
                updateActivityReportItem(
                  input: { patch: { quantity: $quantity }, id: $id }
                ) {
                  clientMutationId
                }
              }
            `,
            variables: {
              id: this.item.id,
              quantity: this.item.quantity,
            },
          })
          .then((response) =>
            this.$emit("activity-report-item-updated", response)
          )
          .catch((err) => console.error("failed to save report item", err));
      },
      500,
      { leading: true }
    ),
  },

  computed: {
    label() {
      return labels[this.item.category];
    },
    quantity: {
      get: function () {
        return parseInt(this.item.quantity);
      },
      set: function (val) {
        this.item.quantity = val;
      },
    },
  },

  filters: {},
};
</script>

<style lang="scss" scoped>
.ActivityReportItem {
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--pale-grey);
  name {
    flex: 1;
  }
  input {
    width: 5em;
  }
}
</style>
